import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { FAQS } from '../data/content';
import { Reveal } from './Reveal';
export function FAQ() {
  const [open, setOpen] = React.useState<number | null>(0);
  return <section id="faq" className="bg-canvas py-20 sm:py-24" data-id="element-29" data-mp="1hb8e4b5g09nt">
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 lg:grid-cols-[0.7fr_1.3fr] lg:px-8" data-id="element-30" data-mp="1cft11lf9ehsg">
        <Reveal data-id="element-31" data-mp="2a0xeqne8q7ow">
          <p className="text-[11px] font-semibold uppercase tracking-overline text-brand-600" data-id="element-32" data-mp="2a1gz0ard5863">
            FAQ
          </p>
          <h2 className="mt-4 text-[2rem] font-semibold leading-[1.1] tracking-[-0.02em] text-ink-900 sm:text-[2.4rem]" data-id="element-33" data-mp="2042kwhswwvgy">
            Preguntas frecuentes
          </h2>
          <p className="mt-5 max-w-sm text-[14.5px] leading-relaxed text-ink-500" data-id="element-34" data-mp="1v4pz80ds1ufy">
            Información general. Para condiciones concretas, consulta siempre la
            plataforma.
          </p>
        </Reveal>

        <div className="divide-y divide-line overflow-hidden rounded-2xl border border-line bg-white shadow-card" data-id="element-35" data-mp="js5nurgbitfu">
          {FAQS.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-36" data-mp="1apkhz3qwehz5" data-mpi={i}>
                <h3 data-id="element-37" data-mp="1aoix67k2yh48">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left transition-colors duration-200 ease-expo hover:bg-brand-50" data-id="element-38" data-mp="1apaqfbq7g2rc">
                    <span className="text-[15px] font-semibold text-ink-900" data-id="element-39" data-mp="s0w0ysvjcwsn">
                      {faq.question}
                    </span>
                    <PlusIcon className={`h-4 w-4 shrink-0 text-brand-600 transition-transform duration-200 ease-expo ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-40" data-mp="iymrm6c079gu" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-41" data-mp="2kuvm287nsukk">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-42" data-mp="2fwalu8seqaw4">
                      <p className="max-w-2xl px-6 pb-6 text-[14.5px] leading-relaxed text-ink-500" data-id="element-43" data-mp="2ymjyydpqfn2l">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}